import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { clearToken } from '../utils/api';
import './Sidebar.css';

const NAV = [
  {
    label: 'Manage',
    items: [
      { to: '/clients',       icon: '👥', label: 'Clients' },
      { to: '/projects',      icon: '📁', label: 'Projects' },
      { to: '/vendors',       icon: '🏪', label: 'Vendors' },
      { to: '/subscriptions', icon: '🔄', label: 'Subscriptions' },
    ]
  },
  {
    label: 'Finance',
    items: [
      { to: '/reports', icon: '📊', label: 'Reports' },
    ]
  }
];

export default function Sidebar() {
  const navigate = useNavigate();

  function handleLogout() {
    clearToken();
    navigate('/');
  }

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <div className="logo-mark">
          <span>80</span>
          <span>20</span>
        </div>
        <div className="logo-text">
          <div className="logo-title">8020 Finance</div>
          <div className="logo-sub">Manager</div>
        </div>
      </div>

      <nav className="sidebar-nav">
        {NAV.map(group => (
          <div key={group.label} className="nav-group">
            <div className="nav-group-label">{group.label}</div>
            {group.items.map(item => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  'nav-item' + (isActive ? ' active' : '')
                }
              >
                <span className="nav-icon">{item.icon}</span>
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <div className="sidebar-bottom">
        <NavLink
          to="/dashboard"
          className={({ isActive }) => 'nav-item' + (isActive ? ' active' : '')}
        >
          <span className="nav-icon">🏠</span>
          <span>Dashboard</span>
        </NavLink>
        <NavLink
          to="/settings"
          className={({ isActive }) => 'nav-item' + (isActive ? ' active' : '')}
        >
          <span className="nav-icon">⚙️</span>
          <span>Settings</span>
        </NavLink>
        <button className="nav-item nav-logout" onClick={handleLogout}>
          <span className="nav-icon">🚪</span>
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}
